export default __webpack_public_path__ + "static/media/logo.8bc2d60e.svg";